import Brochure from "@/models/Brochure";

export function BrochureInfilter(brochure: Brochure, search: string, filters: {
  VlsCode: string;
  InterestAreas: string[];
  StudyLanguages: string[];
  StudyTypes: string[];
  StudyForms: string[];
  subjects: string[];
  ShippingMethods: string[];
}): boolean { let interestAreaFilter = filters.InterestAreas.length === 0;
  let studyTypeFilter = filters.StudyTypes.length === 0;
  let studyFormFilter = filters.StudyForms.length === 0;
  let subjectsFilter = filters.subjects.length === 0;
  let shippingMethodFilter = filters.ShippingMethods.length === 0;
  let languageFilter = filters.StudyLanguages.length === 0;

  const searchFilter =
  search == null ||
  search == "" ||
    brochure.name
      .toLowerCase()
      .indexOf(search.toLowerCase()) >= 0;

  // [1] Check the interest filter
  if (filters.InterestAreas.length > 0) {
    if (brochure.interestAreas && brochure.interestAreas.length > 0) {
      interestAreaFilter = false;
      brochure.interestAreas.forEach(element => {
        if (!interestAreaFilter) {
          interestAreaFilter = filters.InterestAreas.includes(
            element.id
          );
        }
      });
    }
  }


  if (filters.StudyLanguages.length > 0) {
    let dutch = false;
    let english = false;

    if (filters.StudyLanguages.includes("NL"))
      dutch = brochure.nederlands;

    if (filters.StudyLanguages.includes("EN"))
      english = brochure.engels;

    languageFilter = dutch || english;
}

  if (filters.StudyTypes.length > 0) {
    if (brochure.studytype) {
      studyTypeFilter = filters.StudyTypes.includes(
        brochure.studytype.id
      );
    }
  }

  if (filters.ShippingMethods.length > 0) {
    if (brochure.shippingmethod) {
      shippingMethodFilter = filters.ShippingMethods.includes(
        brochure.shippingmethod.id
      );
    }
  }

  if (filters.StudyForms.length > 0) {
    if (brochure.studyform) {
      studyFormFilter = filters.StudyForms.includes(
        brochure.studyform.id
      );
    }
  }

  if (filters.subjects.length > 0) {
    if (brochure.subject) {
      subjectsFilter = filters.subjects.includes(
        brochure.subject.id
      );
    }
  }

  return (
    interestAreaFilter &&
    searchFilter &&
    studyTypeFilter &&
    studyFormFilter &&
    subjectsFilter &&
    shippingMethodFilter &&
    languageFilter

  );
}
